import { Injectable } from '@angular/core';
import { GlobalVariablesService } from './global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class DataExportService {

  constructor(private globalVars: GlobalVariablesService) { }

  exportData(featureSet: any, data: any, formatted?: boolean, timespan?: string) {
    let dataToExport: ExportData[] = [];
    let targetIndex = data.length - 1;
    let type = featureSet.type;
    for (let i = 0; i < data.length; i++) {
      let element = data[i];
      let exportElement = new ExportData();

      if(element.hasOwnProperty("timestamp")){
        exportElement.date = element.timestamp;
      }

      if(element.hasOwnProperty("value")){
        exportElement.value = element.value;
        if (type && (type === "energy" || type === "lw600")) {
          exportElement.cost = (exportElement.value * this.globalVars.getTarrif())/100;
        }
      }

      if (type && (type === "energy" || type === "lw600")) {
        if (i === targetIndex) {
          switch (timespan) {
            case "weekly":
              exportElement.totalEnergy = featureSet.total;
              break;
            case "monthly":
              exportElement.totalEnergy = featureSet.monthly_total;
              break;
          }
          exportElement.totalCost = (this.globalVars.getTarrif() * exportElement.totalEnergy)/100;
        } else {
          exportElement.totalEnergy = "";
          exportElement.totalCost = "";
        }
      }

      if(formatted){  
          let date = new Date(exportElement.date);
          exportElement.date = date.toString();
          switch(type){
            case "energy":
            case "lw600":
              break;
            case "switch":
            case "motion":
              if(exportElement.value === 1){
                exportElement.value = "On";
              }
              if (exportElement.value === 0) {
                exportElement.value = "Off";
              }  
              
          }
        

        if(exportElement.cost){
          this.formatCost(exportElement);
        }
      }

      dataToExport.push(exportElement);
    }

    let headers = Object.keys(dataToExport[0]);

    this.exportToCsv(featureSet.name, dataToExport, headers);
  }

  private formatCost(exportElement){
    let cost = exportElement.cost;
    cost = cost * 10;
    cost = Math.round(cost);
    exportElement.cost = cost / 100;
    if(exportElement.totalCost && exportElement.totalCost !== ""){
      let totalCost = exportElement.cost;
      totalCost = totalCost * 10;
      totalCost = Math.round(totalCost);
      exportElement.totalCost = totalCost / 100;
    }
  }

  exportToCsv(filename: string, rows: object[], headers?: string[]): void {
    if (!rows || !rows.length) {
      return;
    }

    const separator: string = ",";

    const keys: string[] = Object.keys(rows[0]);

    let columHearders: string[];

    if (headers) {
      columHearders = headers;
    } else {
      columHearders = keys;
    }

    const csvContent =
      "sep=,\n" +
      columHearders.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];

          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');


          cell = cell.replace(/[^\x00-\x7F]/g, ""); //remove non-ascii characters
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {

      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

  }
}

class ExportData {

  public date: any;
  public value: any;
  public cost?: any;
  public totalCost?: any;
  public totalEnergy?: any;
}
